import React, { useEffect } from 'react';
import './ScreenerCriteriaSelect.css';
import ToggleButton from '../../../Common/ToggleButton/ToggleButton';
import { Criteria } from '../../../../types/screener.type';
import { IDictionary } from '../../../../types/common.type';

interface ScreenerCriteriaSelectProps {
  criteria: Criteria[];
  setCriteria: (criteria: Criteria[]) => void;
  groups: IDictionary<string>;
}

const ScreenerCriteriaSelect = ({
  criteria,
  setCriteria,
  groups,
}: ScreenerCriteriaSelectProps) => {
  const MAX_SELECTED_CRITERIA = 10;
  const isAllSelected = criteria.every((item) => item.selected);
  const isSomeSelected = criteria.some((item) => item.selected);
  const selectedCount = criteria.filter((item) => item.selected).length;

  const toggleAllMarkets = (selected: boolean) => {
    setCriteria(
      criteria.map((item: Criteria) => ({
        ...item,
        selected: !selected,
      })),
    );
  };

  const toggleCriteria = (id: string, selected: boolean) => {
    const index = criteria.findIndex((item) => item.id === id);
    if (index >= 0) {
      // If trying to select and already at max, prevent selection
      if (!selected && selectedCount >= MAX_SELECTED_CRITERIA) {
        return;
      }

      const newCriteria = [...criteria];
      newCriteria[index] = {
        ...newCriteria[index],
        selected: !selected,
        selectedMin: undefined,
        selectedMax: undefined,
        pendingMinMax: false,
      };
      setCriteria(newCriteria);
    }
  };
  return (
    <div className="screener-advanced-criteria-select-options">
      {Object.values(groups).map((group) => (
        <div
          key={group}
          className="screener-advanced-criteria-select-options-group"
        >
          <div className="screener-advanced-criteria-select-options-group-label">
            {group}
          </div>

          {criteria
            .filter((item) => item.group === group)
            .map((option) => {
              const isDisabled =
                !option.selected && selectedCount >= MAX_SELECTED_CRITERIA;
              return (
                <div
                  key={option.id}
                  id={`option-${option.id}`} // Unique ID for each option
                  className={`screener-advanced-criteria-select-option-item-container ${isDisabled ? 'disabled' : ''}`}
                  role="option" // Indicates an option in the listbox
                  aria-selected={option.selected} // Indicates if the option is selected
                  aria-disabled={isDisabled}
                  onClick={() =>
                    !isDisabled && toggleCriteria(option.id, option.selected)
                  }
                  tabIndex={isDisabled ? -1 : 0} // Make each item focusable for keyboard navigation
                  style={{
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  <ToggleButton
                    className="screener-advanced-criteria-select-option-item-toggle-button"
                    label={option.label}
                    checked={option.selected}
                    indeterminate={false}
                    onClick={() =>
                      !isDisabled && toggleCriteria(option.id, option.selected)
                    }
                  />
                </div>
              );
            })}
        </div>
      ))}
    </div>
  );
};

export default ScreenerCriteriaSelect;
